import { IAsset } from '../contentful';

export const getContentfulBackgroundImage = (background: IAsset[]) => {
	// A video can be added together with an image in the background field, so need to filter the image
	const image = background.find((item) => item.type === 'image');
	return image?.fields.file.url;
};
